<div class="position-relative overflow-hidden" 
    [ngClass]="hasTopMargin 
        ? (loading === undefined 
            ? 'initialMargin' 
            : (loading || !hideMargin
                ? (contentHeight === '0px'
                    ? 'increasingMargin'
                    : 'initialMargin'
                ) 
                : loaded 
                    ? 'decreasingMargin'
                    : ''
            )
        ) 
        : ''
    "
> 
    <div #content [ngClass]="{ 'initialHeight': loading === undefined, 'loadingHeight': loading && contentHeight === '0px',
        'loadingFinalHeight': loaded, 'infiniteLoadingMaxHeight': !loaded && loading === false }">
        <ng-content></ng-content>    
    </div>
    <urban-loader [localized]="true" [disappearCondition]="loading === false"/>
</div>

